import { useState } from 'react';

export default function HeroSection() {
  const [searchText, setSearchText] = useState('');

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
  };

  return (
    <section className="relative w-full h-[580px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20movie%20theater%20interior%20with%20golden%20spotlight%20beams%20cutting%20through%20soft%20ambient%20light%2C%20elegant%20red%20velvet%20curtains%2C%20projector%20rays%20illuminating%20floating%20dust%20particles%2C%20rich%20warm%20amber%20and%20gold%20tones%2C%20luxurious%20classic%20cinema%20atmosphere%2C%20soft%20bokeh%20lights%2C%20editorial%20photography%20style%2C%20bright%20and%20inviting%20mood&width=1920&height=1080&seq=hero-bg-bright-2026&orientation=landscape"
        alt="快看影视 - 高清免费电影在线观看"
        title="快看影视 - 高清免费电影在线观看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-background-50/90" />

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/20 backdrop-blur-md border border-white/30 mb-6">
            <i className="ri-fire-line text-amber-300 text-sm"></i>
            <span className="text-xs text-white font-medium">每日更新 · 海量片源 · 免费观看</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white font-heading leading-tight mb-4 drop-shadow-lg">
            高清电影<span className="text-amber-300">免费</span>在线观看
          </h1>
          <p className="text-sm md:text-base text-white/90 max-w-xl mx-auto mb-8 leading-relaxed drop-shadow-md">
            快看影视提供<strong className="text-white">高清电影</strong>免费在线观看，<strong className="text-white">电影大全</strong>、<strong className="text-white">最新电影</strong>不缓冲流畅秒播，播放稳定不卡顿，满足你的观影需求。
          </p>

          <form onSubmit={handleSearch} className="flex flex-col sm:flex-row gap-3 max-w-lg mx-auto">
            <div className="flex-1 relative">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
              <input
                type="text"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="搜索你喜欢的电影..."
                className="w-full pl-11 pr-4 py-3.5 rounded-xl bg-white/90 backdrop-blur-sm border border-white/50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-500/30 transition-all duration-200"
              />
            </div>
            <button
              type="submit"
              className="px-8 py-3.5 rounded-xl bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
            >
              搜索电影
            </button>
          </form>

          <div className="flex items-center justify-center gap-6 mt-8 flex-wrap">
            <div className="flex items-center gap-2">
              <i className="ri-movie-line text-amber-300 text-lg drop-shadow"></i>
              <span className="text-xs text-white/80">海量片源</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-4k-line text-amber-300 text-lg drop-shadow"></i>
              <span className="text-xs text-white/80">高清画质</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-speed-up-line text-amber-300 text-lg drop-shadow"></i>
              <span className="text-xs text-white/80">流畅秒播</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-amber-300 text-lg drop-shadow"></i>
              <span className="text-xs text-white/80">安全免费</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}